import { render } from "./ReasonsDetail.vue?vue&type=template&id=64783196&scoped=true"
import script from "./ReasonsDetail.vue?vue&type=script&lang=js"
export * from "./ReasonsDetail.vue?vue&type=script&lang=js"

import "./ReasonsDetail.vue?vue&type=style&index=0&id=64783196&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64783196"]])

export default __exports__